import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, Card, Modal, Spin } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { axiosErrorHandler } from '../../../../../swzutils';
import HasPermissions from "../../../../../containers/HasPermissions";
import InsurancePolicyModal from "./InsurancePolicyModal";
import InsuranceCategory from "../../../enums/InsuranceCategory";
import { DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
const TabInsurancePolicies = ({ tenantId }) => {
    const [showSpinner, setShowSpinner] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editPolicy, setEditPolicy] = useState(undefined);
    const tableRef = useRef(null);
    const [modal, contextHolder] = Modal.useModal();
    const confirmDelete = (insurancePolicy) => {
        modal.confirm({
            title: 'Are you sure?',
            content: 'Delete policy number ' + insurancePolicy.policyNumber,
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => execDelete(insurancePolicy)
        });
    };
    const execDelete = (insurancePolicy) => {
        setShowSpinner(true);
        axios.delete(`/admin/v1/tenants/${tenantId}/insurance-policies/${insurancePolicy.id}`)
            .then(( /*response*/) => tableRef.current?.removeRecordById(insurancePolicy.id))
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    const add = () => {
        setModalVisible(true);
        setEditPolicy(undefined);
    };
    const edit = (editPolicy) => {
        setModalVisible(true);
        setEditPolicy(editPolicy);
    };
    const onPolicyAddedOrUpdated = (policy) => {
        if (editPolicy) {
            tableRef.current?.updateRecord(policy);
        }
        else {
            tableRef.current?.addRecord(policy);
        }
        setModalVisible(false);
        setEditPolicy(undefined);
    };
    const onModalCancel = () => {
        setModalVisible(false);
        setEditPolicy(undefined);
    };
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const columns = [{
            title: 'Policy Number',
            dataIndex: 'policyNumber',
            width: '10%'
        }, {
            title: 'Description',
            dataIndex: 'description',
            width: '25%'
        }, {
            title: 'Insurer',
            dataIndex: 'insurerName',
            width: '20%'
        }, {
            title: 'Category',
            dataIndex: 'category',
            width: '15%',
            render: text => InsuranceCategory.description(text)
        }, {
            title: 'Expiry',
            dataIndex: 'expiryDate',
            width: '15%',
            render: (text /*, record*/) => {
                return dayjs(text).format("DD/MM/YYYY");
            }
        }, {
            title: 'Action',
            key: 'action',
            className: 'centre',
            width: '15%',
            render: (text, record) => (_jsxs("span", { className: "actions", children: [_jsx(HasPermissions, { permissions: ['admin:tenant:insurancePolicy:update'], children: _jsx(Button, { onClick: () => edit(record), icon: _jsx(EditOutlined, {}) }) }), "\u00A0", _jsx(HasPermissions, { permissions: ['admin:tenant:insurancePolicy:delete'], children: _jsx(Button, { onClick: () => confirmDelete(record), icon: _jsx(DeleteOutlined, {}) }) })] }))
        }];
    return (_jsxs(Spin, { spinning: showSpinner, children: [contextHolder, _jsxs(Card, { title: "Insurance Policies", type: "inner", variant: 'borderless', children: [_jsxs("div", { className: "table-operations-inline", children: [_jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) }), _jsx(Button, { onClick: add, icon: _jsx(PlusOutlined, {}), children: "Add an Insurance Policy" })] }), _jsx(PaginatedFilterableTable, { tableKey: 'insurancePoliciesTable', ref: tableRef, dataUri: `/admin/v1/tenants/${tenantId}/insurance-policies`, columns: columns, filterTenantId: tenantId })] }), _jsx(InsurancePolicyModal, { open: modalVisible, tenantId: tenantId, insurancePolicy: editPolicy, onPolicyAddedOrUpdated: onPolicyAddedOrUpdated, onCancel: onModalCancel })] }));
};
export default TabInsurancePolicies;
